import { render, staticRenderFns } from "./PollEditorMultiple.vue?vue&type=template&id=42c66a3c&scoped=true"
import script from "./PollEditorMultiple.vue?vue&type=script&lang=js"
export * from "./PollEditorMultiple.vue?vue&type=script&lang=js"
import style0 from "./PollEditorMultiple.vue?vue&type=style&index=0&id=42c66a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c66a3c",
  null
  
)

export default component.exports